var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.route=='/employer/bundles')?_c('Bundles'):_vm._e(),(_vm.route=='/employer/bundles/add-new')?_c('AddNew'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }